// src/features/Home.jsx
import React from 'react';
import { Container } from 'react-bootstrap';

const Home = () => {
  return (
    <Container style={{ marginTop: '1rem' }}>
      <h1>Bienvenido a Clauger</h1>
      <p>Selecciona un módulo en la barra lateral.</p>
    </Container>
  );
};

export default Home;
